<template>
  <!-- 画面の予約日時は端末の時刻で表示する。海外の端末ではメール（日本時間）と数字が食い違うので、
       端末が日本時間以外のときだけ、上の時刻がお住まいの地域の時刻であることと日本時間を添える -->
  <p v-if="jstText" :class="$style.note">※上記はお住まいの地域の時刻です。日本時間では {{ jstText }} です。</p>
</template>

<script>
import cf from '@/mixins/commonFunctions';

export default {
  name: 'JstTimeNote',
  mixins: [cf],
  props: {
    // 予約日時（schedules.date の ISO 文字列）
    date: {
      type: String,
      default: null,
    },
  },
  computed: {
    jstText() {
      return this.jstSlotLabel(this.date);
    },
  },
};
</script>

<style lang="scss" module>
.note {
  margin-top: 4px;
  font-size: 12px;
  color: var(--gray-side);
}
</style>
